import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { nanoid } from 'nanoid';
import { firestore } from '../../contexts/FirebaseContext';
// import { sum, map, filter, uniqBy, reject } from 'lodash';

// auxiliary functions

function createTokenF(userid, privlevel = 1, days = 1, unlimited = false) {
  const rstring = nanoid(20);
  const token = `dagbackend-${rstring}-${privlevel}`;
  const newToken = {
    token,
    userid,
    privlevel,
    expires: moment().add(days, 'days').toDate(),
    unlimited,
    uses: 100 * days
  };
  firestore.collection('tokens').doc(token).set(newToken);
  return newToken;
}

//  slice

const initialState = {
  token1: '',
  token2: '',
  token3: '',
  token4: '',
  token5: '',
  currrentCotizacion: '',
  cotizacionInfo: null,
  cotizaciones: [],
  direccionesCot: {
    direcciones: [],
    direccionRemit: [],
    direccionDesti: [],
    direccionRemitSelec: {},
    direccionDestiSelec: {},
    idSelectedRemit: null,
    idSelectedDesti: null
  },
  envios: [],
  envioDetalle: null,
  products: [],

  // id de la wallet a la que se debe cobrar
  idWalletToPay: null,

  showTarifas: false,
  tarifasTotal: [],
  cotTarifasError: false,
  errorResponseCotizacion: { timestamp: null, errorResponse: null },
  tarifas: [],
  tarifasRedpack: [],
  paqueterias: [],
  userList: [],
  checkout: {
    activeStep: 0,
    cart: [],
    subtotal: 0,
    subtotalEmpaquetado: 0,
    total: 0,
    discount: 0,
    shipping: 0,
    billing: null
  },
  paymentCheckout: {
    loopCounter: 0,
    itemsSuccess: [],
    itemsError: [],
    collectedMoney: 0,
    listErrors: []
  },
  lockerInfo: {}
};

const slice = createSlice({
  name: 'dagpacket',
  initialState,
  reducers: {
    // manejod de idWalletToPay que se usa cuando el usuario devuelve un item al carrito de compras
    setIdWalletToPay: (state, action) => {
      const id = action.payload;

      state.idWalletToPay = id;
    },

    removeIdWalletToPay: (state) => {
      state.idWalletToPay = null;
    },

    // payment checkout

    addListErrors: (state, action) => {
      const errorObj = action.payload;

      state.paymentCheckout.listErrors = [...state.paymentCheckout.listErrors, errorObj];
    },
    resetListErrors: (state) => {
      state.paymentCheckout.listErrors = [];
    },
    resetLoopCounter: (state) => {
      state.paymentCheckout.loopCounter = 0;
    },
    resetItemsSuccess: (state) => {
      state.paymentCheckout.itemsSuccess = [];
    },
    resetItemsError: (state) => {
      state.paymentCheckout.itemsError = [];
    },
    resetCollectedMoney: (state) => {
      state.paymentCheckout.collectedMoney = 0;
    },

    setLoopCounter: (state) => {
      const val = state.paymentCheckout.loopCounter + 1;
      state.paymentCheckout.loopCounter = val;
    },
    setItemsSuccess: (state, action) => {
      const id = action.payload;
      state.paymentCheckout.itemsSuccess = [...state.paymentCheckout.itemsSuccess, id];
    },
    setItemsError: (state, action) => {
      const id = action.payload;
      state.paymentCheckout.itemsError = [...state.paymentCheckout.itemsError, id];
    },
    setCollectedMoney: (state, action) => {
      const value = action.payload;
      const newVal = state.paymentCheckout.collectedMoney + value;
      state.paymentCheckout.collectedMoney = newVal;
    },
    // locker info

    getLockerInfoAction: (state, action) => {
      state.lockerInfo = action.payload;
    },
    //
    resetDirectionRemitSelect: (state) => {
      state.direccionesCot.direccionRemitSelec = {};
    },
    resetDirectionDestitSelect: (state) => {
      state.direccionesCot.direccionDestiSelec = {};
    },

    addTemporalDirection: (state, action) => {
      const direction = action.payload;
      state.direccionesCot.direcciones = [...state.direccionesCot.direcciones, direction];
    },

    getDirections: (state, action) => {
      const direcciones = action.payload;
      state.direccionesCot.direcciones = direcciones;
    },
    setIdSelectedRemit: (state, action) => {
      state.direccionesCot.idSelectedRemit = action.payload;
    },
    setIdSelectedDesti: (state, action) => {
      state.direccionesCot.idSelectedDesti = action.payload;
    },
    addDirectionRemit: (state, action) => {
      const newDirect = action.payload;
      state.direccionesCot.direccionRemit = [...state.direccionesCot.direccionRemit, newDirect];
    },

    addDirectionDesti: (state, action) => {
      const newDirect = action.payload;
      state.direccionesCot.direccionDesti = [...state.direccionesCot.direccionDesti, newDirect];
    },

    selectRemitDireccion: (state, action) => {
      const dir = action.payload;
      state.direccionesCot.direccionRemitSelec = dir;
    },

    selectDestiDireccion: (state, action) => {
      const dir = action.payload;
      state.direccionesCot.direccionDestiSelec = dir;
    },

    // checkout

    restartCart: (state, action) => {
      const itemsList = action.payload ? action.payload : [];
      state.checkout.cart = itemsList;
      state.checkout.subtotal = 0;
      state.checkout.total = 0;

      // // ---local storage
      // localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },

    resetCart: (state) => {
      state.checkout.cart = [];
      state.checkout.subtotal = 0;
      state.checkout.total = 0;

      // ---local storage
      localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },

    updateCartItem: (state, action) => {
      const obj = action.payload;
      const id = obj.object_id;
      const newArr = state.checkout.cart.filter((item) => item.object_id !== id);
      state.checkout.cart = [...newArr, obj];

      // ---local storage
      localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },

    addCart: (state, action) => {
      const product = action.payload;
      // const isEmptyCart = state.checkout.cart.length === 0;
      state.checkout.cart = [...state.checkout.cart, product];
      let sd = Number(state.checkout.subtotal);
      state.checkout.subtotal = state.checkout.cart.map((c) => (sd += Number(c.shippingValue)));
      // slice.reducers.calcSubtotal();

      // ---local storage
      localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },
    removeItem: (state, action) => {
      const id = action.payload;
      const newCart = state.checkout.cart.filter((item) => item.object_id !== id);
      state.checkout.cart = newCart;

      // ---local storage
      localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },
    calcSubtotal: (state) => {
      let subTotal = 0;
      let total = 0;
      let subTotalEmpaquetado = 0;
      let descuento = 0;
      // eslint-disable-next-line array-callback-return
      state.checkout.cart.map((item) => {
        if (item.descuentoIncrementoType === 'increase') {
          subTotal += parseFloat(item.shippingValue || item.originalShippingValue);
        } else {
          subTotal += parseFloat(item.originalShippingValue || item.shippingValue);
        }
      });
      state.checkout.cart.map((item) => (total += parseFloat(item.shippingValue || item.enteredAmount)));
      // eslint-disable-next-line array-callback-return
      state.checkout.cart.map((item) => {
        if (item?.descuentoIncrementoType === 'discount') {
          descuento -= parseFloat(item?.descuentoIncrementoValue || 0);
        }
        // if (item?.descuentoIncrementoType === 'increase') {
        //   descuento += parseFloat(item?.descuentoIncrementoValue || 0);
        // }
      });
      // eslint-disable-next-line array-callback-return
      state.checkout.cart.map((item) => {
        if (item?.cuponValue) {
          descuento -= parseFloat(item?.cuponValue || 0);
        }
      });
      // state.checkout.cart.map((item) => (descuento += parseFloat(item?.descuentoIncrementoValue || 0)));
      state.checkout.subtotal = subTotal;
      state.checkout.total = total;
      state.checkout.discount = descuento;

      state.checkout.cart.map((item) => (subTotalEmpaquetado += parseFloat(item.empaquetadoValue || 0)));
      state.checkout.subtotalEmpaquetado = subTotalEmpaquetado;
    },

    resetActiveStep(state) {
      state.checkout.activeStep = 0;
    },
    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },
    // TOKENS
    setToken1: (state, action) => {
      state.token1 = action.payload;
    },
    setToken2: (state, action) => {
      state.token2 = action.payload;
    },
    setToken3: (state, action) => {
      state.token3 = action.payload;
    },
    setToken4: (state, action) => {
      state.token4 = action.payload;
    },
    setToken5: (state, action) => {
      state.token5 = action.payload;
    },
    generateToken: (_state, action) => {
      const { userid, days, privlevel, unlimited } = action.payload;
      createTokenF(userid, days, unlimited, privlevel);
    },
    // COTIZACIONES
    setCotizaciones: (state, action) => {
      state.cotizaciones = action.payload;
    },
    // COTIZACION
    setCotizacion: (state, action) => {
      state.currentCotizacion = action.payload;
    },

    // TARIFAS
    setShowTarifa: (state, action) => {
      state.showTarifas = action.payload;
    },

    setCotTarifasError: (state, action) => {
      state.cotTarifasError = action.payload;
    },
    setErrorCotizacion: (state, action) => {
      state.errorResponseCotizacion = action.payload;
    },

    getTarifasTotalAction: (state, action) => {
      const data = action.payload;
      state.tarifasTotal = [...state.tarifasTotal, ...data];
    },

    resetTarifasTotalAction: (state) => {
      state.tarifasTotal = [];
    },

    setTarifas: (state, action) => {
      state.tarifas = action.payload;
    },

    setTarifasRedpack: (state, action) => {
      state.tarifasRedpack = action.payload;
    },
    // CONTIZACION INFO
    setCotizacionInfo: (state, action) => {
      state.cotizacionInfo = action.payload;
    },
    // PAQUETERIAS
    setPaqueterias: (state, action) => {
      state.paqueterias = action.payload;
    },
    setUserList: (state, action) => {
      state.userList = action.payload;
    },

    // ENVIOS
    setEnviosList: (state, action) => {
      state.envios = action.payload;
    },

    setEnvioDetalle: (state, action) => {
      state.envioDetalle = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  onBackStep,
  onNextStep,
  resetCart,
  addTemporalDirection,
  addDirectionRemit,
  addDirectionDesti,
  selectRemitDireccion,
  selectDestiDireccion,
  setIdSelectedRemit,
  setIdSelectedDesti,
  getDirections,
  resetDirectionRemitSelect,
  resetDirectionDestitSelect,
  getLockerInfoAction,
  getTarifasTotalAction,
  resetTarifasTotalAction,
  setShowTarifa,
  setCotTarifasError,
  setErrorCotizacion,
  setLoopCounter,
  setItemsSuccess,
  setItemsError,
  setCollectedMoney,
  resetActiveStep,

  resetLoopCounter,
  resetItemsSuccess,
  resetItemsError,
  resetCollectedMoney,
  updateCartItem,

  addListErrors,
  resetListErrors,

  setIdWalletToPay,
  removeIdWalletToPay
} = slice.actions;

// checkuot

export const restartCartAction = (item) => (dispatch) => {
  dispatch(slice.actions.restartCart(item));
  dispatch(slice.actions.calcSubtotal());
};

export const addCartAction = (item) => (dispatch) => {
  dispatch(slice.actions.addCart(item));
  dispatch(slice.actions.calcSubtotal());
};

export const updateCartAction = (item) => (dispatch) => {
  dispatch(slice.actions.updateCartItem(item));
  dispatch(slice.actions.calcSubtotal());
};

export const removeItemAction = (id) => (dispatch) => {
  dispatch(slice.actions.removeItem(id));
  dispatch(slice.actions.calcSubtotal());
};
// Cotizaciones

export function setCotizaciones(cotizaciones = []) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setCotizaciones(cotizaciones));
    } catch (error) {
      console.error(error);
    }
  };
}

// Cotizaciones

export function setCotizacion(cotizacion = '') {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setCotizacion(cotizacion));
    } catch (error) {
      console.error(error);
    }
  };
}

// Cotizaciones

export function setTarifas(tarifas = []) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setTarifas(tarifas));
    } catch (error) {
      console.error(error);
    }
  };
}

export function setTarifasRedpack(tarifas = []) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setTarifasRedpack(tarifas));
    } catch (error) {
      console.error(error);
    }
  };
}

// Cotizacion Info

export function setCotizacionInfo(cotizacionInfo = {}) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setCotizacionInfo(cotizacionInfo));
    } catch (error) {
      console.error(error);
    }
  };
}

// paqueterias
export function setPaqueterias(paqueterias = []) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setPaqueterias(paqueterias));
    } catch (error) {
      console.log(error);
    }
  };
}

// Lista usuarios
export function setUserList(userList = []) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setUserList(userList));
    } catch (error) {
      console.log(error);
    }
  };
}

// paquetes envios

export function setEnviosList(envios = []) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setEnviosList(envios));
    } catch (error) {
      console.log(error);
    }
  };
}

export function setEnvioDetalle(detalle = {}) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setEnvioDetalle(detalle));
    } catch (error) {
      console.log(error);
    }
  };
}

// Tokens

export function createToken(userid, privlevel = 1, days = 1, unlimited = false) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.generateToken({ userid, days, unlimited, privlevel }));
    } catch (e) {
      console.error(e);
    }
  };
}

export function setToken1(token) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setToken1(token));
    } catch (e) {
      console.error(e);
    }
  };
}

export function setToken2(token) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setToken2(token));
    } catch (e) {
      console.error(e);
    }
  };
}

export function setToken3(token) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setToken3(token));
    } catch (e) {
      console.error(e);
    }
  };
}

export function setToken4(token) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setToken4(token));
    } catch (e) {
      console.error(e);
    }
  };
}

export function setToken5(token) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setToken5(token));
    } catch (e) {
      console.error(e);
    }
  };
}
